import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./components/LoginPage";
import CsvUploader from "./components/CsvUploader";
import { AuthProvider } from "./components/AuthContext";
import PrivateRoute from "./components/PrivateRoute";
import Confirm from "./components/Confirm";
import Getline from "./components/getline";
import Welcome from "./components/welcome";
import ResetPassword from "./components/ResetPassword"; // ✅ แม้เป็น .js ก็ไม่ต้องใส่นามสกุล
import Forecast from "./components/forecast"; // ✅ เพิ่มบรรทัดนี้
import AddEmail from "./components/AddEmail";
import Po from "./components/po"; // ✅ เพิ่มบรรทัดนี้
function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Login />} />
        {/* <Route path="/getline" element={<Getline />} /> */}
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/reset-password" element={<ResetPassword />} />{" "}
        <Route path="/forecast" element={<Forecast />} /> {/* ✅ เพิ่ม route */}
        <Route path="/add-email" element={<AddEmail />} />
        <Route path="/po" element={<Po />} /> {/* ✅ เพิ่ม route */}
        <Route
          path="/upload"
          element={
            <PrivateRoute>
              <CsvUploader />
            </PrivateRoute>
          }
        />
      </Routes>
    </AuthProvider>
  );
}

export default App;

// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Login from "./components/LoginPage";
// import CsvUploader from "./components/CsvUploader";
// import { AuthProvider } from "./components/AuthContext";
// import PrivateRoute from "./components/PrivateRoute"; // Import PrivateRoute

// import Confirm from "./components/Confirm"; // เพิ่มบรรทัดนี้
// import Getline from "./components/getline"; // เพิ่มบรรทัดนี้

// function App() {
//   return (
//     <AuthProvider>
//       {/* ตั้งค่า basename */}
//       <Router basename="/">
//         <Routes>
//           {/* หน้า Login */}
//           <Route path="/" element={<Login />} />

//           {/* เส้นทางที่ไม่ต้องล็อกอิน */}
//           {/* <Route path="/confirm" element={<Confirm />} /> */}
//           <Route path="/getline" element={<Getline />} />

//           {/* ป้องกันการเข้าถึงหน้า /upload */}
//           <Route
//             path="/upload"
//             element={
//               <PrivateRoute>
//                 <CsvUploader />
//               </PrivateRoute>
//             }
//           />
//         </Routes>
//       </Router>
//     </AuthProvider>
//   );
// }

// export default App;
